module.exports = __webpack_public_path__ + "img/archery1.0c1d7214.svg";